import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";
import { BACKEND_URL as baseUrl } from './backendUrl';

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export function formatCurrency(amount, currency = 'USD') {
  const currencyConfig = {
    USD: { locale: 'en-US', currency: 'USD' },
    RUB: { locale: 'ru-RU', currency: 'RUB' },
  };
  
  const config = currencyConfig[currency.toUpperCase()] || currencyConfig.USD;
  
  return new Intl.NumberFormat(config.locale, {
    style: 'currency',
    currency: config.currency,
  }).format(amount);
}

export function formatDate(dateString, locale = 'ru-RU') {
  const date = new Date(dateString);
  return new Intl.DateTimeFormat(locale, {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  }).format(date);
}

export function formatDateTime(dateString, locale = 'ru-RU') {
  const date = new Date(dateString);
  return new Intl.DateTimeFormat(locale, {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  }).format(date);
}

/**
 * Сегодняшняя дата ПО ЧАСАМ ЧЕЛОВЕКА, в формате YYYY-MM-DD.
 *
 * Не через toISOString(): он отдаёт дату по UTC, и у всех восточнее Лондона
 * вечер уже числился бы завтрашним днём, а у западных — вчерашним. Прогноз
 * «на сегодня» должен совпадать с тем, какое сегодня у человека на часах.
 */
export function localTodayISO(d = new Date()) {
  const pad = (n) => String(n).padStart(2, '0');
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
}

export function getDaysRemaining(expiresAt) {
  if (!expiresAt) return null;
  const now = new Date();
  const expires = new Date(expiresAt);
  const diffTime = expires - now;
  const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
  return diffDays;
}

export function getAccessBadge(accessType) {
  const badges = {
    free: { label: 'Бесплатно', className: 'badge-free' },
    trial: { label: 'Пробный', className: 'badge-trial' },
    paid: { label: 'Оплачено', className: 'badge-paid' },
    referral: { label: 'Реферал', className: 'badge-paid' },
  };
  return badges[accessType] || badges.free;
}

export function getRoleBadge(role) {
  const badges = {
    admin: { label: 'Администратор', className: 'role-admin' },
    manager: { label: 'Менеджер', className: 'role-manager' },
    user: { label: 'Пользователь', className: 'role-user' },
  };
  return badges[role] || badges.user;
}

export function truncateText(text, maxLength = 100) {
  if (text.length <= maxLength) return text;
  return text.slice(0, maxLength) + '...';
}

export function getInitials(email) {
  return email.charAt(0).toUpperCase();
}

export function copyToClipboard(text) {
  return navigator.clipboard.writeText(text);
}

export function generateRefLink(refCode, appSlug = null) {
  const path = appSlug ? `/apps/${appSlug}` : '/';
  return `${baseUrl}${path}?ref=${refCode}`;
}
